import { Card, Row, Col } from 'antd';
import { DetailRow } from './DetailRow';

/**
 * GuestDetailsCard - Displays information for each guest in the order
 */
const GuestDetailsCard = ({ guestDetails }) => {
    if (!guestDetails || guestDetails.length === 0) return null;

    return (
        <Card
            className="mb-3"
            headStyle={{
                background: '#1890ff',
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
                padding: '16px 24px',
            }}
            bodyStyle={{ padding: '24px' }}
            bordered={false}
            title={<span style={{ color: '#fff', fontSize: '18px', fontWeight: '600' }}>Guest Details</span>}
        >
            {guestDetails.map((guest, index) => (
                <div key={guest.id || index} className={index > 0 ? 'mt-4 pt-4' : ''} style={index > 0 ? { borderTop: '1px solid #f0f0f0' } : {}}>
                    <h6 style={{ fontSize: '15px', fontWeight: '600', marginBottom: '16px', color: '#1890ff' }}>
                        Guest {index + 1}
                    </h6>
                    <Row gutter={[24, 0]}>
                        <Col xs={24} md={12}>
                            <DetailRow icon="user" label="Name" value={guest.name} />
                            <DetailRow icon="users" label="Gender" value={guest.gender} />
                            <DetailRow icon="calendar" label="Birth Date" value={guest.birthDate} />
                            <DetailRow icon="hash" label="Registration No" value={guest.registrationNo} />
                        </Col>
                        <Col xs={24} md={12}>
                            <DetailRow icon="phone" label="Phone" value={guest.phoneNo} />
                            <DetailRow icon="mail" label="Email" value={guest.email} />
                            <DetailRow icon="user-check" label="Parent Customer" value={guest.parentCustomerName} />
                            <DetailRow
                                icon="activity"
                                label="Treatment/Solution"
                                value={
                                    guest.treatmentData?.map(t => t.treatmentName).join(', ') ||
                                    guest.solutionData?.map(s => s.solutionName).join(', ')
                                }
                            />
                        </Col>
                    </Row>
                </div>
            ))}
        </Card>
    );
};

export default GuestDetailsCard;
